const uiConfig = {
  global: {
    style: {
      fontSize: {
        fontSize: '1.2rem',
      },
      width100Per: {
        width: '100%',
      },
      boxShadowNill: {
        boxShadow: 'none',
      },
      cBorder: {
        border: '1px solid rgba(0, 0, 0, 0.12)',
      },
    },
  },
};
export default uiConfig;
